var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},_vm._l((_vm.list),function(item){return _c('van-collapse-item',{key:item.id,attrs:{"border":_vm.showBorder,"title":item.title,"name":item.id}},[_c('p',{domProps:{"innerHTML":_vm._s(item.content)}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }